<template>
    <div id="login-app" class="d-flex">

        <div class="copyright">{{year}} {{ $t('reserved-rights') }}</div>

        <v-row cols="12" class="d-flex">

            <v-col sm="6" class="background-div" :style="`background: url(${bgLogin}) no-repeat center top;`">
                <div class="container container-col-box">
                    <div class="row box-row align-items-center">
                        <div class="col-12 mt-200">
                            <div class="box--logo">
                                <img :src="logo" width="180px"/>

                                <p class="p-left pt-12 mb-0">{{titleLogin}}</p>
                                <p class="p-left subTitle">{{subTitleLogin}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>

            <v-col sm="6" class="login-div" >
                <div class="mt-16 pt-14 cols-12 pl-12 pr-12 col-lg-10 col-xl-8 offset-lg-1 offset-xl-2 col__box--form">

                    <div class="div-form-title">
                        <span>{{ $t('reset-password') }}</span>
                        <p class="p-right"></p>
                    </div>


                    <v-form @submit.prevent="postResetPassword" v-model="valid" autocomplete="on" v-show="!showReset">


                        <label class="form-label white--text">{{ $t('password-caps') }}</label>
                        <v-text-field
                            v-model="password"
                            type="password"
                            required
                            autocomplete="new-password"
                            solo
                            dense
                            :rules="[rulesPassword.required, rulesPassword.min]"
                        >
                        </v-text-field>
                        <label class="form-label white--text">{{ $t('confirm-password-caps') }}</label>
                        <v-text-field
                            v-model="confirmPassword"
                            type="password"
                            required
                            autocomplete="new-password"
                            solo
                            dense
                            :rules="[rulesPassword.required, rulesPassword.min, rulesPassword.verify]"
                        >
                        </v-text-field>

                        <div class="col-10 offset-1 btn-login">
                            <button type="submit" class="btn btn-primary btn-block" :disabled="!valid">
                                {{ $t('confirm-caps') }}
                            </button>
                        </div>


                    </v-form>

                    <div class="div-form-title mt-14 mb-6" v-show="showReset">

                        <p class="mt-3" style="font-size: 14px;">
                            {{ $t('update-success') }}
                        </p>
                    </div>
                    <v-row cols="12" class="d-flex flex-row" v-show="showReset">
                        <!--<v-col sm="6">
                            <v-checkbox color="primary" v-model="checkbox" label="Lembrar login"></v-checkbox>
                        </v-col>-->

                        <v-col sm="12" class="text-center align-self-center">
                            <v-btn class="white--text" style="padding: 0px" text @click="onClickToLogin">{{ $t('back-to-login') }}</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-col>


        </v-row>

    </div>
</template>

<script>

import { AuthServicesResetPassword } from "@services/AuthServices";
import { isEmail } from "@src/utils/validations.js";

export default {
    name: "login-internal",
    data() {
        return {
            password: "",
            confirmPassword: "",
            valid: false,
            token:"",

            rulesEmail: [v => !!v || this.$t('required-input'), v => isEmail(v) || this.$t('email-validate-input')],
            rulesPassword: {
                required: value => !!value || this.$t('required-input'),
                min: v => (v != undefined && v.length >= 8) || this.$t('min-8-chars'),
                verify: v=> v === this.password || this.$t('diff-password')
            },

            modalRequest: {
                show: false,
                message: '',
                invalid: false,
            },

            year: '',
            isRecovery: false,
            isRecoveryTrue: false,
            validRecovery: false,
            emailRecovery: "",

            logo:'',
            bgLogin:'',
            titleLogin:'',
            subTitleLogin:'',

            isValidEnv: process.env.VUE_APP_DOMAIN,
            showReset: false

        };
    },

    methods: {
        postResetPassword(){

            let body = {
                newPassword: this.password,
            }

            this.$store.commit("loadings/setStateLoadingTemplate", true);
            return AuthServicesResetPassword(body,this.token)
                .then(response => {
                    this.showReset = true;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalRequest.invalid = true;
                    this.password = '';
                    this.confirmPassword = '';
                    this.valid = false;
                    throw new Error("error to do login", error);
                })
                .finally(() => {
                    this.$store.commit("loadings/setStateLoadingTemplate", false);
                });

        },

        onClickToLogin() {
            this.$router.push({ name: 'login' });
        }
    },

    mounted() {
        this.token = this.$route.params.token
        this.year = new Date().getFullYear();
        this.$store.commit('loadings/setStateLoadingTemplate', true);
        this.$store.commit('loadings/setStateLoadingTemplate', false);

        let colors = JSON.parse(localStorage.getItem('@datadrive:domain'))

        if (colors) {
            this.logo = colors.companyLogoBeforeLogin
            this.bgLogin = colors.backgroundImage
            this.titleLogin = colors.loginTitle
            this.subTitleLogin = colors.loginSubTitle
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@sass/_variables.scss';

    #login-app {
        // NOT GOOD - JUST FOR NOW
        height: 100vh;
        margin-left: -20px;
        margin-right: -20px;
        margin-top: -32px;

        @media (max-width: 768px) {
            margin-top: -10px;
        }

        .copyright {
            position: absolute;
            margin-left: 10%;
            bottom: 20px;
            color: white;
            font-size: 1em;
            z-index: 90;

            @media (max-width: 1440px) {
                margin-left: 6%;
            }

            @media (max-width: 1440px) {
                margin-left: 3%;
            }

            @media (max-width: 426px) {
                font-size: 0.8em;
                bottom: -145px;
            }
            @media (max-width: 320px) {
                font-size: 0.8em;
                bottom: -265px;
            }
        }


        .background-div {
            background-size: cover !important;
            .mt-200{
                margin-top: 200px;
            }
            .container-box, .row-box, .container-col-box, .box-row {
                height: 100%;
            }

            .container-box, .row-box {
                padding: 0;
                margin: 0;
                height: 100vh;
            }

            .container-col-box {
                color: white;
                transition: 0.4s;
            }

            .p-left {
                font-weight: 600;
                text-shadow: 0 3px 6px #00000029;
                font-size: 3em;
                letter-spacing: 0.8px;
                line-height: 1.3em;
                transition: 0.4s;
                &.subTitle{
                    font-size: 2.5em;
                    @media (max-width: 1440px) {
                        font-size: 1.5em;
                    }
                }
                @media (max-width: 1440px) {
                    font-size: 2em;
                }

                @media (max-width: 425px) {
                    text-align: center;
                }
            }

            .box--logo {
                display: table;
                margin: 0 auto;
                @media (max-width: 1440px) {
                    margin-left: 3%;
                }
                img{
                    @media (max-width: 425px) {
                        justify-content: center;
                        align-items: center;
                        margin: 0 auto;
                        text-align: center;
                        display: flex;
                    }

                }
            }


        }

        .login-div {
            background: var(--v-bgLogin-base);

            .div-form-title {
                span {
                    color: white;
                    font-weight: 700;
                    font-size: 40px;
                    letter-spacing: 0.8px;
                    line-height: 44px;
                }

                p {
                    color: white;
                    font-size: 18px;
                    font-weight: 400;
                    letter-spacing: 0.18px;
                    line-height: 30px;
                    margin-top: 6px;
                }
            }

            .col__box--form {
                transition: 0.4s;

                ::v-deep .v-label {
                    margin-bottom: 0px !important;
                    color: white;
                }

                ::v-deep .v-btn__content {
                    font-family: Lato;
                    text-transform: initial;
                }
            }

            .p-right {
                font-size: 18px;
                font-weight: 400;
                letter-spacing: 0.18px;
                line-height: 30px;
                margin-top: -5px;
                margin-bottom: 60px;
            }

            h3 {
                font-weight: 700;
                font-size: 40px;
                letter-spacing: 0.8px;
                line-height: 44px;
            }

            label {
                font-size: 12px;
                letter-spacing: 0.48px;
            }

            .checkbox {
                margin-top: 8px;
            }

            .btn {
                color: white;
                font-weight: 900;
                border-radius: 64px;
                margin: 3px;
                width: 100%;
                height: 50px;
                font-weight: 900;
                border-radius: 64px;
                background-color: var(--v-primary-base);
                border-color: var(--v-primary-base);
                &:hover{
                    background-color: var(--v-primary-darken2);
                    border-color: var(--v-primary-darken2);
                }
            }
        }
    }

</style>
